const offset = 250;
const duration = 250;
export default class BackToTop {
  backToTop: HTMLAnchorElement;
  constructor() {
    this.backToTop = document.getElementById('js-back-to-top') as HTMLAnchorElement;

    if (this.backToTop) {
      window.addEventListener('scroll', this.backToTopHandler.bind(this));
      this.backToTop.addEventListener('click', this.scrollToTop.bind(this));
    }
  }

  /**
   * Show hide button based on scroll offset
   */
  backToTopHandler() {
    if (window.pageYOffset > offset) {
      setTimeout(() => {
        this.backToTop.style.bottom = '0';
      }, duration);
    } else {
      setTimeout(() => {
        this.backToTop.style.bottom = '-50px';
      }, duration);
    }
  }

  /**
   * Scroll to top of the page
   * @param event - Event object
   */
  scrollToTop(event: Event){
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
